<template>
  <div>
    <div class="d-flex justify-end mb-3">
      <v-btn @click="planCreate">
        <v-icon class="mr-1" icon="mdi-plus"></v-icon>
        <span>Створити план</span>
      </v-btn>
    </div>
    <plan-item
      v-for="plan in planList"
      :key="plan.id"
      :plan="plan"
      class="mb-3"
      @click="$router.push({ name: 'plan-single', params: { id: plan.id } })"
      @update="onUpdate">
    </plan-item>

    <b-pagination
      v-model="paginationData.currentPage"
      :length="paginationData.lastPage"></b-pagination>
  </div>
</template>

<script lang="ts">
import { reactive, ref, watch } from 'vue'
import { openDialog } from '@/dialog'
import { CustomDate, getPersonName } from 'best-modules/utils'
import PlanItem from './PlanItem.vue'
import { planList as planListRequest } from '@/requests/plan'
import { BPagination } from 'best-modules/components'

export default {
  name: 'PlanList',
  components: { PlanItem, BPagination },
  methods: { getPersonName, CustomDate },
  setup() {
    const paginationData = reactive({
      currentPage: 1,
      lastPage: 1,
    })
    const planList = ref<any[]>([])

    const getPlanList = () => {
      return planListRequest({ page: paginationData.currentPage }).then(res => {
        paginationData.currentPage = res.current_page
        paginationData.lastPage = res.last_page
        planList.value = res.data
      })
    }

    const planCreate = () => {
      return openDialog({
        name: 'Plan',
        action: 'create',
        params: {
          cb: plan => {
            planList.value = [
              { ...plan, progress: { completed: 0, total: 0 } },
              ...planList.value,
            ]
          },
        },
      })
    }

    const onUpdate = (updatedPlan: any) => {
      planList.value = planList.value.map(p => {
        return p.id === updatedPlan.id ? updatedPlan : p
      })
    }

    watch(() => paginationData.currentPage, getPlanList, { immediate: true })

    return { planList, planCreate, onUpdate, paginationData }
  },
}
</script>

<style lang="scss" scoped></style>
